import React from "react";
import styled from "styled-components";
import {
  GlossyThemeProvider,
  Spacing,
  ZIndexes,
  background,
  border,
  prettyScrollbars,
} from "@glossy";

export interface IProps {
  body: React.ReactNode;
  sidebar: React.ReactNode;
  displaySidebar: boolean;
}

const Root = styled.div`
  display: flex;
  z-index: ${ZIndexes.Content};
  width: 100%;
  height: 100%;
  background-color: ${background};
`;

const Body = styled.div`
  flex-grow: 1;
  padding: ${Spacing.ExtraLarge};
  ${prettyScrollbars()};
`;

const Sidebar = styled.div`
  flex: 320px 0 0;
  ${prettyScrollbars()};
  border-right: solid 1px ${border};
`;

const PanelsCardLibraryLayout = ({
  body,
  sidebar,
  displaySidebar = true,
}: IProps) => (
  <GlossyThemeProvider name="edition">
    <Root>
      {displaySidebar && <Sidebar>{sidebar}</Sidebar>}
      <Body>{body}</Body>
    </Root>
  </GlossyThemeProvider>
);

export default PanelsCardLibraryLayout;
